import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class SettingsStore {
	private currentSettings = localStorage.getItem('ITOHub.Settings') ? JSON.parse(localStorage.getItem('ITOHub.Settings')) : {};
	private _currentSettings$ = new BehaviorSubject<any>(this.currentSettings);
	public settingsChanged$ = this._currentSettings$.asObservable();

	constructor() {}

	public set(key: string, value: any): void {
		this.currentSettings[key] = value;
		this._currentSettings$.next(this.currentSettings);
		localStorage.setItem('ITOHub.Settings', JSON.stringify(this.currentSettings));
	}

	public get(key: string): any {
		return this.currentSettings[key];
	}
}
